// extracted by mini-css-extract-plugin
module.exports = {"button":"Ir","reviewSort":"Jr"};